import { faComment } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {
  MAX_PROMOCODE_GENERATION_COUNT,
  MAX_PROMOCODE_REWARD_IN_HOURS,
  PROMO_CODE_ACTIVE_OPTIONS,
  PROMO_CODE_GENDER_OPTIONS,
  PROMO_CODE_PAID_OPTION_VALUES,
  PROMO_CODE_REWARD_TYPE_OPTIONS
} from "../../../../constants/input-entries-constants";
import { ALL_COUNTRY_PICKER_ENTRIES } from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import getPromoCodeGenerationStore from "../../../../stores/communications-store/promocode-generate";
import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";
import { isDefinedString } from "et3-type-guards";

const PromoCodeForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          icon={faComment}
          type={"text"}
          label={i18n.get("PROMO_CODE_DESCRIPTION")}
          placeHolder={i18n.get("PROMO_CODE_DESCRIPTION")}
          value={getPromoCodeGenerationStore().promoCodeDescripion.get()}
          onChoose={(value: string) =>
            getPromoCodeGenerationStore().setPromoCodeDescripion(value)
          }
          onBlur={() => {}}
          style={{}}
          onEnter={() => {}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          icon={faComment}
          type={"number"}
          label={i18n.get("PROMO_CODE_REWARD_IN_HOURS")}
          placeHolder={i18n.get("PROMO_CODE_REWARD_IN_HOURS")}
          value={getPromoCodeGenerationStore().promoCodeRewardInHours.get()}
          onChoose={(value: number) => {
            const maxVipInHours = MAX_PROMOCODE_REWARD_IN_HOURS;
            if (value > maxVipInHours) {
              getPromoCodeGenerationStore().setPromoCodeRewardInHours(0);
              getCorePopUpStore().showHelperMessage(
                "PROMOCODE_REWARD_IN_HOURS"
              );
            } else {
              getPromoCodeGenerationStore().setPromoCodeRewardInHours(value);
            }
          }}
          onBlur={() => {}}
          style={{}}
          onEnter={() => {}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("PROMO_CODE_REWARD_TYPE")}
          options={PROMO_CODE_REWARD_TYPE_OPTIONS}
          onChoose={(value: TEt3PickerSingleValue) => {
            if (
              value.value !== "VIP" &&
              getPromoCodeGenerationStore().promoCodeForGender.get().value !==
                "m"
            ) {
              getCorePopUpStore().showHelperMessage(
                "PROMOCODE_NOT_SUPPORTED_FOR_GENDER"
              );
              return;
            }
            getPromoCodeGenerationStore().setPromoCodeRewardType(value);
          }}
          value={getPromoCodeGenerationStore().promoCodeRewardType.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          icon={faComment}
          type={"number"}
          label={i18n.get("PROMO_CODE_VIP_MAX_USAGE")}
          placeHolder={i18n.get("PROMO_CODE_VIP_MAX_USAGE")}
          value={getPromoCodeGenerationStore().promoCodeMaxUsage.get()}
          onChoose={(value: number) =>
            getPromoCodeGenerationStore().promoCodeMaxUsage.set(value)
          }
          onBlur={() => {}}
          style={{}}
          onEnter={() => {}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("PROMO_CODE_ACTIVE")}
          options={PROMO_CODE_ACTIVE_OPTIONS}
          onChoose={(value: TEt3PickerSingleValue) => {
            getPromoCodeGenerationStore().setPromoCodeIsActive(value);
          }}
          value={getPromoCodeGenerationStore().promoCodeIsActive.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("PROMO_CODE_NATIONALITY")}
          options={[
            { value: "ALL", label: "All" },
            ...ALL_COUNTRY_PICKER_ENTRIES
          ]}
          onChoose={(value: TEt3PickerSingleValue) => {
            getPromoCodeGenerationStore().setPromoCodeForNationality(value);
          }}
          value={getPromoCodeGenerationStore().promoCodeForNationality.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("GENDER")}
          options={PROMO_CODE_GENDER_OPTIONS}
          onChoose={(value: TEt3PickerSingleValue) => {
            const rewardTypeValue =
              getPromoCodeGenerationStore().promoCodeRewardType.get().value;
            if (
              value.value !== "m" &&
              rewardTypeValue !== "VIP" &&
              isDefinedString(rewardTypeValue)
            ) {
              getCorePopUpStore().showHelperMessage(
                "PROMOCODE_NOT_SUPPORTED_FOR_GENDER"
              );
              return;
            }
            getPromoCodeGenerationStore().promoCodeForGender.set(value);
          }}
          value={getPromoCodeGenerationStore().promoCodeForGender.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("PROMO_CODE_PAID")}
          options={PROMO_CODE_PAID_OPTION_VALUES}
          onChoose={(value: TEt3PickerSingleValue) => {
            getPromoCodeGenerationStore().promoCodeForPaid.set(value);
          }}
          value={getPromoCodeGenerationStore().promoCodeForPaid.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          icon={faComment}
          type={"number"}
          label={i18n.get("PROMO_CODE_NUMBER_OF_CODES")}
          placeHolder={i18n.get("PROMO_CODE_NUMBER_OF_CODES")}
          value={getPromoCodeGenerationStore().numberOfPromoCodes.get()}
          onChoose={(value: number) => {
            if (value > MAX_PROMOCODE_GENERATION_COUNT) {
              getPromoCodeGenerationStore().setNumberOfPromoCodes(
                MAX_PROMOCODE_GENERATION_COUNT
              );
              getCorePopUpStore().showHelperMessage(
                "PROMOCODE_NUMBER_OF_CODES_MAX"
              );
            } else {
              getPromoCodeGenerationStore().setNumberOfPromoCodes(value);
            }
          }}
          onBlur={() => {}}
          style={{}}
          onEnter={() => {}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Date
          hasMax={false}
          hasMin={true}
          label={i18n.get("PROMO_CODE_START_DATE")}
          dateInputObservable={getPromoCodeGenerationStore().startDate}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Date
          hasMax={false}
          hasMin={true}
          label={i18n.get("PROMO_CODE_EXPIRY_DATE")}
          dateInputObservable={getPromoCodeGenerationStore().expirationDate}
          isEnabled={true}
        />
      </ET3Div>
    </React.Fragment>
  );
});
export default PromoCodeForm;
